import { useContext } from 'react';

import { Context } from './IntlWrapper';

const useLocale = () => {
  return useContext(Context);
};

export default useLocale;
